module.exports = __webpack_public_path__ + "static/media/evernote.5ee90763.svg";